import axios from "axios"

axios.interceptors.request.use(
    config => {
        let token = localStorage.token 
        if ( token ) {
            config.headers.authorization = token 
        }
        // config.headers["Content-Type"] = 'application/x-www-form-urlencoded;charset=utf-8'

        return config 
    },
    error => {
        return  Promise.reject( error )
    }
)

axios.interceptors.response.use(
    response => {
        return response
    },
    error => {
        return  Promise.reject( error )
    }
)

export default  axios